module.exports = __webpack_public_path__ + "img/loader.a29f016a.svg";